var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconPlugCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 28,
    cy: 28,
    r: 27.25,
    stroke: "#000064",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 35v4h-4v-4m2 4.05V43M35 21v9a5 5 0 01-5 5h-4a5 5 0 01-5-5v-9m-2 0h18m-13 0v-8m8 8v-8",
    stroke: "#000064",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNTYiIGhlaWdodD0iNTYiIHZpZXdCb3g9IjAgMCA1NiA1NiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4NCjxjaXJjbGUgY3g9IjI4IiBjeT0iMjgiIHI9IjI3LjI1IiBzdHJva2U9IiMwMDAwNjQiIHN0cm9rZS13aWR0aD0iMS41Ii8+DQo8cGF0aCBkPSJNMzAgMzVWMzlIMjZWMzVNMjggMzkuMDVWNDMiIHN0cm9rZT0iIzAwMDA2NCIgc3Ryb2tlLXdpZHRoPSIxLjUiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPg0KPHBhdGggZD0iTTM1IDIxVjMwQzM1IDMwLjY1NjYgMzQuODcwNyAzMS4zMDY4IDM0LjYxOTQgMzEuOTEzNEMzNC4zNjgxIDMyLjUyIDMzLjk5OTggMzMuMDcxMiAzMy41MzU1IDMzLjUzNTVDMzMuMDcxMiAzMy45OTk4IDMyLjUyIDM0LjM2ODEgMzEuOTEzNCAzNC42MTk0QzMxLjMwNjggMzQuODcwNyAzMC42NTY2IDM1IDMwIDM1SDI2QzI0LjY3MzkgMzUgMjMuNDAyMSAzNC40NzMyIDIyLjQ2NDUgMzMuNTM1NUMyMS41MjY4IDMyLjU5NzkgMjEgMzEuMzI2MSAyMSAzMFYyMU0xOSAyMUgzN00yNCAyMVYxM00zMiAyMVYxMyIgc3Ryb2tlPSIjMDAwMDY0IiBzdHJva2Utd2lkdGg9IjEuNSIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+DQo8L3N2Zz4NCg==";
export { SvgIconPlugCircle as ReactComponent };